/**
 * Created by shanie on 1/13/17.
 */
import React from 'react';
import PropTypes from 'prop-types';

// Helpers
import classnames from 'classnames';

// Styles
import styles from './styles/IconButton.scss';

const IconButton = ({
    buttonClass,
    buttonText,
    dataTn,
    disabled,
    IconComponent,
    isMobile,
    isTablet,
    onClick,
    upperCase,
}) => {
    const buttonClasses = classnames(styles.button, buttonClass, {
        [styles.disabled]: disabled,
        [styles.noText]: !buttonText || isMobile || isTablet,
    });

    const textClasses = classnames(styles.text, {
        [styles.upperCase]: upperCase,
    });

    return (
        <button data-tn={dataTn} className={buttonClasses} onClick={onClick}>
            <IconComponent className={styles.icon} />
            {!buttonText || isMobile || isTablet ? null : (
                <span className={textClasses}>{buttonText}</span>
            )}
        </button>
    );
};

IconButton.defaultProps = {
    buttonClass: '',
    isMobile: false,
    isTablet: false,
    upperCase: true,
};

IconButton.propTypes = {
    buttonClass: PropTypes.string,
    buttonText: PropTypes.string,
    dataTn: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    IconComponent: PropTypes.func,
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    onClick: PropTypes.func,
    upperCase: PropTypes.bool,
};

export default IconButton;
